import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { ExtendedOverviewInfo } from "@ugg/shared/api/data-parser/champions/overview";
import { QueueTypeS, QueueTypeC } from "@ugg/shared/utils/queue-type-helpers";
import { normalizeRiotId } from "@ugg/shared/utils/riot-id-helpers";

export function getAllstarChampHighlightUrl(
  championName: string,
  championOverview: ExtendedOverviewInfo | null = null,
  queueId: string = QueueTypeS.RANKED_SOLO,
) {
  const { getRuneKeystoneId } = getRiotAssetsContext();
  const { rec_runes: runes, rec_summoner_spells: summonerSpells, rec_core_items: items } = championOverview || {};
  const keystoneId = getRuneKeystoneId(championOverview?.rec_runes?.active_perks);
  const params = new URLSearchParams({
    champion: championName,
    sort: "score",
    limit: "30",
    summonerSpell1Id: (summonerSpells?.ids[0] || "").toString(),
    summonerSpell2Id: (summonerSpells?.ids[1] || "").toString(),
    perkKeystone: (keystoneId || "").toString(),
    perkSecondaryStyle: (runes?.sub_style || "").toString(),
    queueId: QueueTypeC.convertToInt(queueId).toString(),
  });

  params.append("optional", "summonerSpell1Id");
  params.append("optional", "summonerSpell2Id");
  params.append("optional", "queueId");
  for (const item of items?.ids || []) {
    params.append("matchitemIds", item.toString());
  }

  return `league/clips/playlist?${params.toString()}`;
}

export function getAllstarUserPlaylistClips(riotId: string, region: string) {
  const searchParams = new URLSearchParams({
    riotID: normalizeRiotId(riotId),
    region: region,
    sort: "score",
    limit: "5",
  });

  return `league/clips/playlist?${searchParams.toString()}`;
}
